import type {Dispatch, GetState, ThunkAction} from 'src/reducers';
import type {ApiOptions, ApiPostOptions} from 'src/utils/redux-api';

import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApi from 'src/utils/redux-api';

import {key, fetching} from 'src/utils/redux';
import type {
  SCORECARD,
  SCORECARD_PARAMETER,
  SCORECARD_SECTION,
} from 'src/types/crm';


export const GET_ORG_SCORECARD = 'get-org-scorecard';
export const EDIT_SCORECARD_PARAMETER = 'edit-scorecard-parameter';
export const ADD_SCORECARD_PARAMETER = 'add-scorecard-parameter';
export const DELETE_SCORECARD_PARAMETER = 'delete-scorecard-parameter';
export const DELETE_SCORECARD_SECTION = 'delete-scorecard-section';
export const ADD_SCORECARD_SECTION = 'add-scorecard-section';
export const EDIT_SCORECARD_SECTION = 'edit-scorecard-section';

export type CrmScorecardActions =
  | GetOrgScorecardAction
  | EditScorecardParameterAction
  | AddScorecardParameterAction
  | DeleteScorecardParameterAction
  | DeleteScorecardSectionAction
  | AddScorecardSectionAction
  | EditScorecardSectionAction;

export type GetOrgScorecardAction = {
  type: typeof GET_ORG_SCORECARD;
  payload: SCORECARD;
};

export type EditScorecardParameterAction = {
  type: typeof EDIT_SCORECARD_PARAMETER;
  payload: SCORECARD_PARAMETER;
};

export type AddScorecardParameterAction = {
  type: typeof ADD_SCORECARD_PARAMETER;
  payload: SCORECARD_PARAMETER;
};

export type DeleteScorecardSectionAction = {
  type: typeof DELETE_SCORECARD_SECTION;
  payload: SCORECARD_SECTION;
};

export type DeleteScorecardParameterAction = {
  type: typeof DELETE_SCORECARD_PARAMETER;
  payload: SCORECARD_PARAMETER;
};

export type AddScorecardSectionAction = {
  type: typeof ADD_SCORECARD_SECTION;
  payload: SCORECARD_SECTION[];
};

export type EditScorecardSectionAction = {
  type: typeof EDIT_SCORECARD_SECTION;
  payload: SCORECARD_SECTION;
};

const API_PATH: ApiOptions = {
  apiPath: '/trmapi',
};

export const setOrgScorecard = (payload: SCORECARD): GetOrgScorecardAction => ({
  type: GET_ORG_SCORECARD,
  payload,
});

export const editScorecardParameter = (
  payload: SCORECARD_PARAMETER,
): EditScorecardParameterAction => ({
  type: EDIT_SCORECARD_PARAMETER,
  payload,
});

export const addScorecardParameter = (
  payload: SCORECARD_PARAMETER,
): AddScorecardParameterAction => ({
  type: ADD_SCORECARD_PARAMETER,
  payload,
});

export const deleteScorecardParameter = (
  payload: SCORECARD_PARAMETER,
): DeleteScorecardParameterAction => ({
  type: DELETE_SCORECARD_PARAMETER,
  payload,
});

export const deleteScorecardSection = (
  payload: SCORECARD_SECTION,
): DeleteScorecardSectionAction => ({
  type: DELETE_SCORECARD_SECTION,
  payload,
});

export const addScorecardSection = (
  payload: SCORECARD_SECTION[],
): AddScorecardSectionAction => ({
  type: ADD_SCORECARD_SECTION,
  payload,
});

export const editScorecardSection = (
  payload: SCORECARD_SECTION,
): EditScorecardSectionAction => ({
  type: EDIT_SCORECARD_SECTION,
  payload,
});

const POST_API_OPTIONS: ApiPostOptions = {
  apiPath: '/trmapi',
};

export const getOrgScorecard: () => ThunkAction<void> = flow(
  key(() => `crm/org-scorecard`),
  fetching(),
)(() => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.get(`/api/organization-scorecards`, {}, API_PATH),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: SCORECARD) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: SCORECARD) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(setOrgScorecard(response));
    },
    (error) => {
      // Error handling
    },
  );
});
export const deleteSection: (id: number) => ThunkAction<void> = flow(
  key((id) => `crm/delete-scorecard-section/${id}`),
  fetching(),
)((id) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(`/api/score-sections/${id}/delete`, {}, {}, POST_API_OPTIONS),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: SCORECARD_SECTION) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: SCORECARD_SECTION) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(deleteScorecardSection(response));
    },
    (error) => {
      // Error handling
    },
  );
});

export const editParameter: (payload: {
  id: number;
  name: string;
  sectionId: number;
  description?: string;
}) => ThunkAction<void> = flow(
  key(({id}) => `crm/edit-parameter/${id}`),
  fetching(),
)(({id, name, sectionId, description}) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `/api/score-parameters/${id}`,
      {
        name,
        sectionId,
        description,
      },
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: SCORECARD_PARAMETER) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: SCORECARD_PARAMETER) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(editScorecardParameter(response));
    },
    (error) => {
      // Error handling
    },
  );
});

export const addParameter: (payload: {
  name: string;
  sectionId: number;
}) => ThunkAction<void> = flow(
  key(({name}) => `crm/add-parameter/${name}`),
  fetching(),
)(({name, sectionId}) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `/api/score-parameters`,
      {
        name,
        sectionId,
      },
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: SCORECARD_PARAMETER) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: SCORECARD_PARAMETER) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(addScorecardParameter(response));
    },
    (error) => {
      // Error handling
    },
  );
});

export const deleteParameter: (id: number) => ThunkAction<void> = flow(
  key((id) => `crm/delete-parameter/${id}`),
  fetching(),
)((id) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `/api/score-parameters/${id}/delete`,
      {},
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: SCORECARD_PARAMETER) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: SCORECARD_PARAMETER) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(deleteScorecardParameter(response));
    },
    (error) => {
      // Error handling
    },
  );
});

type AddSection = {
  name: string;
  sectionIds: number[];
  rankOrder: number;
  scorecardId: number;
};

export const addSection: (payload: AddSection) => ThunkAction<void> = flow(
  key(({name}) => `crm/add-section/${name}`),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  const {name, sectionIds, rankOrder, scorecardId} = payload;
  return dispatch(
    reduxApi.post(
      `/api/score-sections/copy?rankOrder=${rankOrder}`,
      {newSectionName: name, sectionIds, scorecardId, rankOrder},
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: SCORECARD_SECTION[]) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: SCORECARD_SECTION[]) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(addScorecardSection(response));
    },
    (error) => {
      // Error handling
    },
  );
});

export const editSection: (payload: {
  name: string;
  id: number;
  rankOrder: number;
  sectionIds: number[];
  scorecardId: number;
}) => ThunkAction<void> = flow(
  key(({id}) => `crm/edit-section/${id}`),
  fetching(),
)(({name, id, rankOrder, sectionIds, scorecardId}) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `/api/score-sections/${id}`,
      {name, rankOrder, sectionIds, scorecardId},
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: SCORECARD_SECTION) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: SCORECARD_SECTION) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(editScorecardSection(response));
    },
    (error) => {
      // Error handling
    },
  );
});
